/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.thinkprocess.ProcessMode
*/
export var ProcessMode;
(function (ProcessMode) {
    ProcessMode["NORMAL"] = "NORMAL";
    ProcessMode["EXPLORING"] = "EXPLORING";
    ProcessMode["PLANNING"] = "PLANNING";
    ProcessMode["EXECUTING"] = "EXECUTING";
})(ProcessMode || (ProcessMode = {}));
//# sourceMappingURL=ProcessMode.js.map